import React, { useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';
import cx from 'classnames';

import Card from '../../../../../../components/Card';
import FlatButton from '../../../../../../components/FlatButton';
import { linkTo, routes } from '../../../../../../helpers/routes';
import PaymentMethodOptions from '../../../../../../pages/renters/payments/payment-methods/AddNewPaymentMethod/components/PaymentMethodOptions';
import { segmentTracking } from '../../../../../../services/utilities';

import styles from './NoPaymentMethod.module.scss';

const NoPaymentMethod = () => {
  const [selected, setSelected] = useState(null);
  const history = useHistory();

  const onAdded = useCallback((_pm, opts) => {
    if (opts?.pendingPlaidVerification) {
      history.push(linkTo(routes.tenantOnboardingStepPaymentMethodVerify));
    } else {
      history.push(linkTo(routes.tenantOnboardingStepPaymentMethodSuccess));
    }
  }, []);
  const noop = useCallback(() => {}, []);

  return (
    <>
      <Card
        padded
        className={cx(styles.rpNoPmContainer, {
          [styles.narrow]: ['debit', 'credit'].includes(selected),
        })}
      >
        <PaymentMethodOptions
          title="How do you want to pay for rent?"
          onAdded={onAdded}
          onSelection={setSelected}
          onPlaidFlowLoaded={noop}
          preferredFor="rent_payments"
        />
      </Card>
      <div className={styles.buttons}>
        <FlatButton
          className={styles.skipButton}
          to={linkTo(routes.tenantOnboardingStepRentersInsurance)}
          onClick={() => {
            segmentTracking('payment_method submit', {
              location: 'Tenant Onboarding Payment Method Page - Skip',
            });
          }}
        >
          Skip for now
        </FlatButton>
      </div>
    </>
  );
};

export default NoPaymentMethod;
